import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MDBCol, MDBRow } from "mdbreact";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Card, Button, Input, Modal } from "react-rainbow-components";
import { Link, useHistory } from "react-router-dom";
import CustomLoader from "../shared/Customloader";
import { customStyles } from "../shared/datatables/styles";
import ShowNotification from "../shared/Notification";
import { RequestInit, RequestInitWithBody } from "../shared/RequestInit";

interface propsToEdit {
  Id: number;
  titre: string;
  photo: string;
  description: string;
  date_enregistrement: string;
  jour: string;
  emission: string;
}

const ListPotcast = () => {
  const [podcast, setpodcast] = useState<any>([]);
  const [pending, setPending] = useState<boolean>(false);
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [todelete, setTodelete] = useState<number | undefined>(undefined);
  const [updated, setUpdated] = useState(false);
  const [errdeleted, setErrDeleted] = useState(false);
  const history = useHistory<any>();

  const fetchPodcast = async () => {
    await fetch(
      "https://admin.radioemotion.be/api/podcast/getall",
      RequestInit as RequestInit
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.response === true) {
          setpodcast(response.data);
          setPending(false);
        }
      })
      .catch((err) => {
        setPending(false);
      });
  };
  useEffect(() => {
    setPending(true);
    fetchPodcast();
  }, []);

  const deleteRow = (Id: number | undefined, confirmed: boolean) => {
    async function deleteRow() {
      const request = await fetch(
        `https://admin.radioemotion.be/api/podcast/delete`,
        RequestInitWithBody({ body: { id: Id }, type: "DELETE" }) as RequestInit
      );
      const response = await request.json();
      if (response.response) {
        fetchPodcast();
      }
    }
    if (confirmed) {
      deleteRow();
    }
    setTodelete(undefined);
    fetchPodcast();
  };

  const FilterComponent = ({ filterText, onFilter, onClear }: any) => (
    <>
      <MDBRow className="mb-2 mt-4" center={true}>
        <MDBCol md="12" className="px-0">
          <Input
            id="search"
            type="text"
            placeholder="Rechercher"
            aria-label="Search Input"
            value={filterText}
            onChange={onFilter}
            onClick={onClear}
          />
        </MDBCol>
      </MDBRow>
    </>
  );
  return (
    <>
      {updated ||
      (history.location.state && history.location.state.passed === true) ? (
        <ShowNotification
          icon="check"
          iconClassName="success-dark-text"
          bodyClassName="px-5 font-weight-bold text-white success-color-dark"
          autohide={5000}
          title=""
          message={"Mise à jour réussie"}
          text="maintenant"
        />
      ) : errdeleted ? (
        <ShowNotification
          icon="times"
          iconClassName="color-red"
          bodyClassName="color-red background-color-red text-white"
          autohide={5000}
          title=""
          message="Une erreur s'est produite"
          text="maintenant"
        />
      ) : null}
      <Modal
        id="confirmDelete"
        title="Voulez-vous vraiment supprimer ?"
        isOpen={showConfirm}
        onRequestClose={() => {
          setShowConfirm(!showConfirm);
          setTodelete(undefined);
        }}
      >
        <div className="d-flex justify-content-between mt-5">
          <Button
            variant="brand"
            label="Annuler"
            onClick={() => setShowConfirm(false)}
          />
          <Button
            variant="brand"
            label="Confirmer"
            onClick={() => {
              setShowConfirm(false);
              deleteRow(todelete, true);
            }}
          />
        </div>
      </Modal>

      <MDBRow>
        <MDBCol md="9" className="offset-2">
          <DataTable
            pointerOnHover={true}
            data={podcast}
            customStyles={customStyles}
            progressPending={pending}
            noHeader={true}
            progressComponent={<CustomLoader />}
            subHeader={true}
            pagination={true}
            className="datatable"
            columns={[
              {
                name: `Id`,
                selector: `Id`,
                sortable: true,
                width: "4%",
                cell: (row: propsToEdit) => (
                  <>
                    <Link
                      to={{ pathname: `/podcast/edit`, state: row }}
                      className="font-size-0dot65vw"
                    >
                      {row.Id}
                    </Link>
                  </>
                ),
              },
              {
                name: `Titre`,
                selector: `titre`,
                sortable: true,
                width: "24%",
                cell: (row) => (
                  <>
                    <Link to={{ pathname: `/podcast/edit`, state: row }}>
                      <p className="cut-text-1l font-size-0dot65vw">
                        {row.titre}
                      </p>
                    </Link>
                  </>
                ),
              },

              {
                name: `Description`,
                selector: `description`,
                sortable: true,
                width: "24%",
                cell: (row) => (
                  <>
                    <Link
                      to={{ pathname: `/podcast/edit`, state: row }}
                      className="font-size-0dot65vw"
                    >
                      {row.description}
                    </Link>
                  </>
                ),
              },
              {
                name: `Date d'enregistrement`,
                selector: `date_enregistrement`,
                sortable: true,
                width: "11%",

                cell: (row) => (
                  <>
                    <Link
                      to={{ pathname: `/podcast/edit`, state: row }}
                      className="font-size-0dot65vw"
                    >
                      {row.date_enregistrement}
                    </Link>
                  </>
                ),
              },
              {
                name: `Emission`,
                selector: `emission`,
                sortable: true,
                width: "11%",
                cell: (row) => (
                  <>
                    <Link
                      to={{ pathname: `/podcast/edit`, state: row }}
                      className="font-size-0dot65vw"
                    >
                      {`${row.emission}`}
                    </Link>
                  </>
                ),
              },
              {
                name: `pochette`,
                selector: `photo`,
                width: "20%",
                cell: (row) => (
                  <>
                    <Link to={{ pathname: `/podcast/edit`, state: row }}>
                      <Card className="my-2">
                        <img
                          className="rounded w-100"
                          alt={row.photo}
                          src={row.photo}
                        />
                      </Card>
                    </Link>
                  </>
                ),
              },
              {
                name: "Delete",
                selector: "Delete",
                width: "6%",
                cell: (row) => (
                  <>
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      onClick={() => {
                        setShowConfirm(true);
                        setTodelete(row.Id);
                      }}
                      className="font-size-1vw mx-auto"
                    ></FontAwesomeIcon>
                  </>
                ),
              },
            ]}
          ></DataTable>
        </MDBCol>
      </MDBRow>
    </>
  );
};

export default ListPotcast;
